module.exports = __webpack_public_path__ + "static/media/ic_search.b7c19851.svg";